import type { BlocksContent } from "@strapi/blocks-react-renderer";

import { CommonBlocksRenderer } from "@widgets/common-blocks-renderer";

import type { RuleType } from "@features/rules-section/model";

import { BrandIcon } from "@shared/ui/brand-icon";
import { Heading } from "@shared/ui/typography";

import s from "./rule-card.module.scss";

export const RuleCard = (props: { data: RuleType }) => {
  const { data } = props;

  return (
    <article className={s.root}>
      {data?.icon?.icon?.name && (
        <BrandIcon
          className={s.icon}
          size={60}
          name={data.icon.icon.name}
          fillColor={data.icon.fillColor}
          strokeColor={data.icon.strokeColor}
        />
      )}
      <div className={s.texts}>
        {data?.title && (
          <Heading level={6} tag="h4">
            {data.title}
          </Heading>
        )}
        {data?.description && (
          <CommonBlocksRenderer data={data.description as BlocksContent} />
        )}
      </div>
    </article>
  );
};

RuleCard.displayName = "RuleCard";
